/* 合法uri */
export function validateURL (textval) {
    const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return urlregex.test(textval)
}
  
/* 小写字母 */
export function validateLowerCase (str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
}
  
/* 大写字母 */
export function validateUpperCase (str) {
    const reg = /^[A-Z]+$/
    return reg.test(str)
}
  
/* 大小写字母 */
export function validatAlphabets (str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
}

/* 手机号 */
export function validateMobile (str) {
    const reg = /^1(3|4|5|6|7|8|9)[0-9]{9}$/
    // console.log(reg.test(str))
    return reg.test(str)
}

/* 纯数字 */
export function validateNumber (str) {
    const reg = /^[0-9]+$/ 
    return reg.test(str)
}
/* 整数 或 小数 */
export function validateFloatNumber (str) {
    const reg = /^\d+\.{0,1}\d{0,1}$/
    return reg.test(str)
}

/* 
身份证号合法性验证 
支持15位和18位身份证号
支持地址编码、出生日期、校验位验证
*/
export function validateIdCard (str) {
    const city = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
    let tip = "";
    let pass = true;
    if (!str || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)?$/i.test(str)) {
        tip = "身份证号格式错误";
    　　pass = false;
    } else if (!city[str.substr(0,2)]) {
    　　tip = "身份证号地址编码错误";
    　　pass = false;
    } else {
    　　// 18位身份证需要验证最后一位校验位
　　    if (str.length == 18) {
    　　    str = str.split('');
    　　    // ∑(ai×Wi)(mod 11)
            // 加权因子
            const factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
            // 校验位
            const parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
            let sum = 0;
            let ai = 0;
            let wi = 0;
            for (let i = 0; i < 17; i++) { 
                ai = str[i];
                wi = factor[i];
                sum += ai * wi;
            }
            let last = parity[sum % 11];
            if (parity[sum % 11] != str[17]) {
                tip = "身份证号校验位错误";
                pass = false;
            }
        }
    }
    return {tip: tip, pass: pass};
}